import { useSortable } from '@dnd-kit/sortable';
import { useEffect, useMemo } from 'react';
import { CSS } from '@dnd-kit/utilities';

const useDataGridSortableContext = (row, collapseAllRows) => {
    const { transform, transition, setNodeRef, isDragging, attributes, listeners } = useSortable({
        id: row.original.id,
    });
    useEffect(() => {
        if (isDragging) {
            collapseAllRows();
        }
    }, [isDragging, collapseAllRows]);
    const dndStyle = useMemo(() => ({
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.8 : 1,
        zIndex: isDragging ? 1 : 0,
        position: 'relative',
    }), [transform, transition, isDragging]);
    return useMemo(() => ({
        isDragging,
        attributes,
        listeners,
        dndStyle,
        setNodeRef,
    }), [isDragging, attributes, listeners, dndStyle, setNodeRef]);
};

export { useDataGridSortableContext as default };
//# sourceMappingURL=useDataGridSortableContext.js.map
